import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  Radio,
} from "antd";
import { useEffect } from "react";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { update } from "../../../../../controllers/store/actions/products/update-product-actions";
import { AxiosError } from "axios";
import SelectGroup from "../../Elements/Select-Group";
import SelectUniversity from "../../Elements/Select-University";
import { Actor, Capacity } from "../../../..";
import { search } from "../../../../../controllers/store/actions/users/search-user-action";
import SelectProducts from "../../Elements/Select-Product-";
interface Props {
  loading?: boolean;
  visible: boolean;
  product?: any;
  onUpdated: () => void;
  onCancel: () => void;
}
const dispatch = store.dispatch;

const UpdateProductModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const updatedProduct = useSelector((state: any) => state.updatedProduct);
  const CapacitiesTypeState = useSelector(
    (state: any) => state.capacitiesTypes
  );

  useEffect(() => {
    form.setFieldsValue({
      ...Props.product,
      groups: Props.product?.groups?.map((g: any) => ({ value: g.groups_id })),
      universities: Props.product?.universities?.map((g: any) => ({
        value: g.universities_id,
      })),
      searchers: Props.product?.searchers?.map((g: any) => ({
        value: g.searchers_id,
      })),
    });
  }, [form, Props.product]);

  return (
    <Modal
      visible={Props.visible}
      width={600}
      title={"Producto"}
      okText={"Modificar producto"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (values: any) => {
            form.validateFields().then(async (data: any) => {
              await dispatch(
                update(Props.product.id, {
                  capacity_type: CapacitiesTypeState.list.find(
                    (c: any) => c.collection_name === Capacity.Products
                  )?.id,
                  nme_producto_pd: data.name,
                  groups: data.groups.map((g: any) => ({ groups_id: g.value })),
                  universities: data.universities.map((g: any) => ({
                    universities_id: g.value,
                  })),
                  searchers: data.searchers.map((s: any) => ({
                    searchers_id: s.value,
                  })),
                  external_code: data.external_code,
                  persona: "",
                  id_producto_pd: data.external_code,
                  fcreacion_pd: new Date().toISOString(),
                  nme_tipologia_pd: data.type,
                  contact_name: data.contact_name,
                  contact_email: data.contact_email,
                })
              );

              Props.onUpdated();
            });
          }}
          name="updateProduct"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={18}>
              <Form.Item
                label="Nombre del producto"
                name="nme_producto_pd"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="Código"
                name="external_code"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Tipologia"
                name="nme_tipologia_pd"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Institución"
                name="universities"
                rules={[{ type: "array" }]}
              >
                <SelectUniversity
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    console.log("universies", selected);
                    form.setFieldValue("universities", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Grupo de investigación"
                name="groups"
                rules={[{ type: "array" }]}
              >
                <SelectGroup
                  onClear={() => {}}
                  mode={"multiple"}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("groups", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Investigadores"
                name="searchers"
                rules={[{ type: "array" }]}
              >
                <SelectGroup
                  onClear={() => {}}
                  mode={"multiple"}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("searchers", selected);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={updatedProduct?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Modificar producto
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};
export default UpdateProductModal;
